import * as React from 'react';
import type { FaqT } from '@mentimeter/plans-content';
import { getPlansFaqConfig } from '@mentimeter/plans-content';
import { useTranslations } from '@mentimeter/i18n';
import { getVisitorDataCache } from '@mentimeter/visitor/visitor-data';
import { useAppState } from '../../../appState';

export const useFaqConfig = ({
  isEducation,
  monthlyBillingIsSupported,
}: {
  isEducation: boolean;
  monthlyBillingIsSupported: boolean;
}) => {
  const [faqConfig, setFaqConfig] = React.useState<FaqT>();
  const { user } = useAppState();
  const { country, preferredLanguage } = getVisitorDataCache();
  const t = useTranslations('plansContentPackage');

  React.useEffect(() => {
    setFaqConfig(
      getPlansFaqConfig({
        t,
        Link: ({ href, children }) => <a href={href}>{children}</a>,
        Bold: ({ children }) => <em>{children}</em>,
        isEducation,
        monthlyBillingIsSupported,
      }),
    );
  }, [
    user,
    preferredLanguage,
    country,
    isEducation,
    t,
    monthlyBillingIsSupported,
  ]);

  return faqConfig;
};
